import { ToastrService } from 'ngx-toastr';
import { ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../core/api/api.service";
import {AccessControlService} from "../../core/access-control/access-control.service";
import {customerRole} from "../../core/access-roles/customer.role";
import {employeeRole} from "../../core/access-roles/employee.role";

@Component({
    selector: 'bergh-upload-floor',
    templateUrl: './upload-floor.component.html',
    styleUrls: ['./upload-floor.component.scss'],
    standalone: false
})
export class UploadFloorComponent implements OnInit {
  @Input() inputData: { data: any };
  @Input() type;
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() newData: EventEmitter<any> = new EventEmitter();
  @Output() mapListData = new EventEmitter();
  public isUploadFile = false;

  public mapList = [];
  public file = null;
  public uploadFile = null;
  public uploadFileName = '';
  public selectedFile = '';
  public mapData: any;
  loading: boolean = false;
  isRevert = false;
  isReplace = false;
  isReplaceModalOpen = false;
  isEdit = true;
  isShow = true;
  constructor(
    private _api: ApiService,
    private toastr: ToastrService,
    private _elemRef: ElementRef,
    private _accessControl: AccessControlService
  ) {}

  ngOnInit(): void {
    this.isShow = !(this._accessControl.isEmployee() ||
      this._accessControl.isCustomer());
    this.getAllMapList();
  }
  public onUploadSelectFile(e) {
    const FILE = <File>e.target.files[0];
    const FORMATS = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'application/pdf',
      'image/x-dwg',
      'application/acad',
      'application/x-acad',
      'application/autocad_dwg',
      'image/x-dwg',
      'application/dwg',
      'application/x-dwg',
      'application/x-autocad',
      'image/vnd.dwg',
      'drawing/dwg',
    ];
    if (FORMATS.includes(FILE.type) || FILE.name.includes('.dwg')) {
      if (FILE.size <= 15000000) {
        this.uploadFile = FILE;
        this.uploadFileName = FILE.name;
      } else {
        this.uploadFile = null;
        this.uploadFileName = '';
        this.toastr.warning('De bestandsgrootte moet kleiner zijn dan 15 MB');
      }
    } else {
      this.toastr.warning(
        'Je kunt alleen bestanden uploaden met de extensie .png, .jpg, .jpeg, .pdf, .dwg',
        'Error'
      );
    }
  }

  public editImageName(data, details, type) {
    if (type === 'EDIT') {
      this.isEdit = true;
      this.isReplace = false;
      this.isRevert = false;
      this.selectedFile = details.name;
      let element =
        data.parentElement.parentElement.parentElement.querySelector(
          '.inputFileName'
        );
      element.classList.remove('d-none');
      element.classList.add('d-flex');
      this.isUploadFile = true;
    }
  }
  cancelInput(data) {
    data.classList.remove('d-flex');
    data.classList.add('d-none');
  }

  public revertMapFile(details) {
    this.loading = true;
    if (details.prevMapName !== null) {
      this._api
        .request('restoreOldMap', '', `${details._id}/restoreOldMap`)
        .subscribe(
          (res) => {
            this.toastr.success(res.message);
            this.getAllMapList();
            this.loading = false;
          },
          (error: any) => {
            console.error(error)
            this.toastr.error(error);
          }
        );
    }
  }
  /**
   * @description this method is used for upload map
   */
  uploadMap() {
    if (this.uploadFile !== null) {
      this.loading = true;
      let form = new FormData();
      if (this.uploadFile !== null) {
        form.append('plan', this.uploadFile);
      }
      this._api
        .request('uploadMap', form, `${this.inputData.data._id}/map`)
        .subscribe(
          (res: any) => {
            this.uploadFileName = '';
            this.uploadFile = null;
            this.toastr.success('Kaart succesvol geüpload');
            this.loading = false;
            this.getAllMapList();
          },
          (error: any) => {
            console.error(error)
            this.loading = false;
          }
        );
    } else {
      this.toastr.warning('Selecteer het bestand');
    }
  }
  /**
   * @description this method is userd for get all map details list
   */
  public getAllMapList() {
    this.loading = true;
    const ID = this.inputData !== undefined ? this.inputData.data._id : 0;
    this._api.request('getMapList', `${ID}/map`).subscribe(
      (res: any) => {
        this.mapList = res;
        this.loading = false;
      },
      (error: any) => {
        console.error(error)
        this.loading = false;
      }
    );
  }
  /**
   *
   * @param data
   * @description this method is used for edit map of existing map
   */
  public editMap(data) {
    const DATA = {
      name: this.selectedFile,
    };

    if (DATA.name.trim().length > 0) {
      this._api.request('editMap', DATA, `${data._id}`).subscribe(
        (res: any) => {
          this.toastr.success('Bestandsnaam succesvol bijgewerkt');
          this.mapListData.emit();
          this.getAllMapList();
        },
        (error: any) => {
          console.error(error)
        }
      );
    } else {
      this.toastr.warning('BESTANDSNAAM ONGELDIG');
    }
  }
  /**
   *
   * @param data
   * @description this method is for replace map of existing map
   */

  public mapReplacementOperation(data) {
    this.isReplaceModalOpen = true;
    this.mapData = data;
  }
  /**
   *
   * @param data
   * @description this method is used for delete map by using ID
   */
  deleteMap(data) {
    this._api.request('deleteFloorMap', `${data._id}`).subscribe(
      (result: any) => {
        this.mapListData.emit();
        this.getAllMapList();
      },
      (error: any) => {
        console.error(error)
        this.getAllMapList();
      }
    );
  }

  openDelete(element) {
    this.removeAllPopup();
    let elem = element.parentElement.parentElement;
    if (elem.classList.contains('active')) {
      elem.classList.remove('active');
    } else {
      elem.classList.add('active');
    }
  }

  cancelDelete(element) {
    let elem = element.parentElement.parentElement.parentElement.parentElement;
    elem.classList.remove('active');
  }

  removeAllPopup() {
    let elements = this._elemRef.nativeElement.querySelectorAll('.btn-delete');
    for (let index = 0; index < elements.length; index++) {
      elements[index].classList.remove('active');
    }
  }

  close() {
    this.cancel.emit();
  }
}
